/**
 * Build a PATCH body for bond status updates.
 * Blanket bonds require a nested `{ bond, blanketbond }` payload; other types use a flat body.
 */
export function buildBondStatusPatchPayload(bondType, status) {
  const updated_at = new Date().toISOString();
  if ((bondType || "").toLowerCase() === "blanket") {
    return {
      bond: { status, updated_at },
      blanketbond: {},
    };
  }
  return { status, updated_at };
}
